import { render } from "./notice-pattern-update.vue?vue&type=template&id=4ae2bdfe"
import script from "./notice-pattern-update.vue?vue&type=script&lang=js"
export * from "./notice-pattern-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__